import type { BlokDisplayCard } from "@/storyblok";

import { type BlokProps, StoryblokComponent } from "@frend-digital/storyblok";
import { AssetBlok, sizes } from "../Asset";
import BlokWrap from "../BlokWrap";
import { MediaLink, hasMediaLink } from "../MediaLink";
import styles from "./DisplayCard.module.css";
import { clsx } from "@frend-digital/ui";

export const DisplayCardBlok = ({
	blok,
	className,
	preview,
	displayBelow,
}: BlokProps<BlokDisplayCard> & {
	className?: string;
	displayBelow?: boolean;
}) => {
	const {
		title,
		media,
		button,
		buttonColor,
		textPositionX = "center",
		textPositionY = "center",
		buttonFollowsYPosition,
	} = blok;

	if (displayBelow) {
		return (
			<BlokWrap editable={blok} className={clsx(className, styles.below)}>
				<div className={styles.content}>
					<div className={styles.imageContainer}>
						{media && (
							<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
								<AssetBlok source={media} sizes={sizes(100, 60)} />
							</MediaLink>
						)}
					</div>
				</div>
				<div>
					{title && <p className={styles.belowTitle}>{title}</p>}

					{button?.map((button) => (
						<StoryblokComponent
							buttonColor={"black"}
							key={button._uid}
							blok={
								{
									...button,
									color: "black",
								} as unknown as NonNullable<BlokDisplayCard["button"]>[number]
							}
							preview={preview}
						/>
					))}
				</div>
			</BlokWrap>
		);
	}

	const infoClass = `${styles.info} ${styles[`x-${textPositionX}`]} ${
		buttonFollowsYPosition && textPositionY === "top"
			? styles.infoTopWithButton
			: styles[`y-${textPositionY}`]
	}`;

	const buttonContainerClass = `${styles.buttonContainer} ${styles[`x-${textPositionX}`]} ${
		buttonFollowsYPosition ? styles[`y-${textPositionY}`] : ""
	}`;

	return (
		<BlokWrap editable={blok} asChild className={className}>
			<div className={styles.content} data-media-linked={hasMediaLink(blok.mediaLink) || undefined}>
				<div className={infoClass}>{title && <p className={styles.title}>{title}</p>}</div>
				<div className={buttonContainerClass}>
					<div style={{ width: "fit-content" }}>
						{button?.map((button) => (
							<StoryblokComponent
								key={button._uid}
								blok={button}
								preview={preview}
								color={buttonColor}
							/>
						))}
					</div>
				</div>

				<div className={styles.imageContainer}>
					{media && (
						<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
							<AssetBlok source={media} sizes={sizes(100, 80)} />
						</MediaLink>
					)}
				</div>
			</div>
		</BlokWrap>
	);
};
